import View from './view';
import {target} from '../utils/dom';

const defaults = {
	el: null,
	triggerSelector: '[data-pdfviewer-trigger]'
};

function renderPDFPage(container, pdfDocument, num, max) {
	console.log('pdfViewer renderPDFPage', num);

	pdfDocument.getPage(num).then((page) => {
		let scale = 3;
		let viewport = page.getViewport(scale);

		// Prepare canvas using PDF page dimensions
		let canvas = document.createElement('canvas');

		container.appendChild(canvas);
		let context = canvas.getContext('2d');
		canvas.height = viewport.height;
		canvas.width = viewport.width;

		// Render PDF page into canvas context
		let renderContext = {
			canvasContext: context,
			viewport
		};
		let renderTask = page.render(renderContext);

		// Wait for page rendering to finish, then get next page
		renderTask.promise.then(() => {
			num++;
			if (num <= max) {
				renderPDFPage(container, pdfDocument, num, max);
			}
		});
	});
}

class PDFViewer extends View {
	constructor(options) {
		super(options, defaults);
		this.pdf = '';
	}

	start() {
		super.start();
		this.triggers = document.queryAll(this.params.triggerSelector);
	}

	initEvents() {
		super.initEvents();
		document.addEventListener('click', this.click.bind(this));
	}

	click(event) {
		let trigger = target(event.target, this.params.triggerSelector);
		if (trigger) {
			let pdf = trigger.getAttribute('data-pdfviewer-trigger');
			console.log('pdfViewer', pdf);
			if (pdf !== this.pdf) {
				this.pdf = pdf;
				this.loadPDF(this.pdf);
			}
		}
	}

	loadPDF(pdf) {
		console.log('pdfViewer loadPDF', pdf);
		let cb = `?${(new Date()).getMilliseconds()}${Math.floor(Math.random() * 1000)}`;

		PDFJS.workerSrc = '/vendor/pdfjs-dist/build/pdf.worker.js';
		if (window.PDFloadingTask) window.PDFloadingTask.destroy();
		window.PDFloadingTask = PDFJS.getDocument(pdf + cb);
		window.PDFloadingTask.promise.then((pdfDocument) => {
			console.log('PDF loaded');
			let container = document.getElementById('slx-pdfviewer__pdf-canvas-container');
			console.log('pdfViewer promise', container);

			// render pages, start with first
			renderPDFPage(container, pdfDocument, 1, pdfDocument.numPages);
		});
	}
}


document.queryAll('.slx-pdfviewer').forEach((item) => {
	const pdfviewer = new PDFViewer({
		el: item
	});
	pdfviewer.start();
});

export default PDFViewer;
